import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, RedirectIfAuthed, RequireAuth } from './components/auth'
import { Layout } from './components/Layout'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { CustomerListPage } from './pages/CustomerListPage'
import { CustomerFormPage } from './pages/CustomerFormPage'
import { CustomerDetailPage } from './pages/CustomerDetailPage'
import { ServerEditPage } from './pages/ServerEditPage'
import { ContractListPage } from './pages/ContractListPage'
import { ReportListPage } from './pages/ReportListPage'
import { ReportNewPage } from './pages/ReportNewPage'
import { AlertsPage } from './pages/AlertsPage'

function gated(node: React.ReactNode) {
  return (
    <RequireAuth>
      <Layout>{node}</Layout>
    </RequireAuth>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route
          path="/login"
          element={
            <RedirectIfAuthed>
              <LoginPage />
            </RedirectIfAuthed>
          }
        />
        <Route path="/" element={gated(<DashboardPage />)} />
        <Route path="/customers" element={gated(<CustomerListPage />)} />
        <Route
          path="/customers/new"
          element={gated(<CustomerFormPage mode="new" />)}
        />
        <Route path="/customers/:id" element={gated(<CustomerDetailPage />)} />
        <Route
          path="/customers/:id/edit"
          element={gated(<CustomerFormPage mode="edit" />)}
        />
        <Route path="/servers/:id/edit" element={gated(<ServerEditPage />)} />
        <Route path="/contracts" element={gated(<ContractListPage />)} />
        <Route path="/reports" element={gated(<ReportListPage />)} />
        <Route path="/reports/new" element={gated(<ReportNewPage />)} />
        <Route path="/alerts" element={gated(<AlertsPage />)} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}
